import { CONTACT_ADDRESS } from "@amtana/i18n/catalog";

// The company that runs the product, written once (ADR-024 §2, D695). The legal notice, the terms
// and the privacy policy read these values through their `{company}`, `{address}` … places, so no
// page can name a different address. Change a fact here and every page follows.

export const LEGAL_ENTITY = {
  company: "Warike UG (haftungsbeschränkt)",
  address: "Frobenstraße 10, 10783 Berlin, Germany",
  director: "Sergio Cardenas Espinoza",
  register: "HRB 228443 B",
  court: "Amtsgericht Berlin-Charlottenburg",
  contact: CONTACT_ADDRESS,
  /** The data protection authority for a company seated in Berlin. */
  authority: "Berliner Beauftragte für Datenschutz und Informationsfreiheit",
} as const;

/** When the texts last changed, as an ISO date; each page shows it in the reader's language. A
 * change to the Terms that people must accept again also moves `TERMS_VERSION` in
 * `@amtana/onboarding-contract` to the same date (ADR-032 point 4). */
export const LEGAL_UPDATED = "2026-10-29";

/** The values each legal text's `{name}` places read. */
export const LEGAL_FILLS: Readonly<Record<keyof typeof LEGAL_ENTITY, string>> = LEGAL_ENTITY;
